"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'PageSwitch_1_0_0',
  tabs: [{
    type: 'business',
    label: 'Business Offers D',
    components: [{
      __typename: 'TextQuote',
      resourceType: 'TextQuote_1_0_0',
      quoteText: 'Business Offers 1',
      caption: 'Business Offers 1'
    }, {
      __typename: 'TextQuote',
      resourceType: 'TextQuote_1_0_0',
      quoteText: 'Business Offers 2',
      caption: 'Business Offers 2'
    }]
  }, {
    type: 'retail',
    label: 'Retail Offers D',
    components: [{
      __typename: 'TextQuote',
      resourceType: 'TextQuote_1_0_0',
      quoteText: 'Retail Offers 1',
      caption: 'Retail Offers 1'
    }, {
      __typename: 'TextQuote',
      resourceType: 'TextQuote_1_0_0',
      quoteText: 'Retail Offers 2',
      caption: 'Retail Offers 2'
    }]
  }]
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;